import '@angular/localize/init';
import { OrderType } from 'graphql-api/baskets-api-interfaces';

export const orderTypeLocale: Record<OrderType, string> = {
  [OrderType.Now]: $localize`:Pulse|Order Type Now Value@@orderTypeNowValue:Now`,
  [OrderType.Future]: $localize`:Pulse|Order Type Future Value@@orderTypeFutureValue:Future`,
  [OrderType.Mixed]: $localize`:Pulse|Order Type Mixed Value@@orderTypeMixedValue:Mixed`,
  [OrderType.None]: '',
};
